import React from 'react';
import { useMount } from 'react-use';

import { useEnvironment } from '#core/Environment';

import { loadMzSync, loadMzAsync } from '../utils/mz';

const MzTracking: React.FC<{}> = ({ children }) => {
  const { enableTracking } = useEnvironment();

  useMount(() => {
    if (typeof window.TES === 'undefined') {
      window.TES = {
        domain: 'https://www.timeshighereducation.com',
        pageMetadata: {}, // stop MZ from erroring on start
      };
      loadMzSync();
      if (enableTracking) {
        loadMzAsync();
      }
    }
  });
  return <>{children}</>;
};

export default MzTracking;
